/**
 * Wishlist Oleum — carga diferida de CSS/JS al primer uso.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'oleum-wishlist-v1';

  function readWishlistIds() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      return list.map(function (item) {
        return String(item.productId || '');
      });
    } catch (e) {
      return [];
    }
  }

  function syncToggleButtonsLight() {
    var ids = readWishlistIds();
    document.querySelectorAll('[data-oleum-wishlist-toggle]').forEach(function (btn) {
      var id = String(btn.getAttribute('data-product-id') || '');
      var active = id && ids.indexOf(id) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function loadStylesheet(href) {
    return new Promise(function (resolve, reject) {
      if (!href || document.querySelector('link[href="' + href + '"]')) {
        resolve();
        return;
      }
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = function () {
        resolve();
      };
      link.onerror = reject;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (!src || document.querySelector('script[src="' + src + '"]')) {
        resolve();
        return;
      }
      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = function () {
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function ensureWishlistLoaded() {
    if (window.OleumWishlist) {
      return Promise.resolve(window.OleumWishlist);
    }
    if (window.__oleumWishlistLoad) {
      return window.__oleumWishlistLoad;
    }

    var assets = window.OleumWishlistAssets || {};
    window.__oleumWishlistLoad = loadStylesheet(assets.css)
      .then(function () {
        return loadStylesheet(assets.productCardCss);
      })
      .then(function () {
        return loadScript(assets.starsJs);
      })
      .then(function () {
        return loadScript(assets.js);
      })
      .then(function () {
        return window.OleumWishlist || null;
      })
      .catch(function (err) {
        window.__oleumWishlistLoad = null;
        throw err;
      });

    return window.__oleumWishlistLoad;
  }

  function handleInteraction(e, openBtn, toggleBtn) {
    if (window.OleumWishlist) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    ensureWishlistLoaded()
      .then(function () {
        if (openBtn && window.OleumWishlist && typeof window.OleumWishlist.open === 'function') {
          window.OleumWishlist.open();
          return;
        }
        if (toggleBtn) {
          toggleBtn.click();
        }
      })
      .catch(function (err) {
        console.warn('[Oleum] Wishlist no disponible:', err);
      });
  }

  function bindLazyTriggers() {
    if (window.__oleumWishlistBootBound) return;
    window.__oleumWishlistBootBound = true;

    document.addEventListener(
      'click',
      function (e) {
        var openBtn = e.target.closest('[data-oleum-wishlist-open]');
        var toggleBtn = e.target.closest('[data-oleum-wishlist-toggle]');
        if (!openBtn && !toggleBtn) return;
        handleInteraction(e, openBtn, toggleBtn);
      },
      true
    );
  }

  function boot() {
    syncToggleButtonsLight();
    bindLazyTriggers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.OleumEnsureWishlist = ensureWishlistLoaded;
})();
